<template>
    <div class="preview-container" v-if="projectIntro.show">
        <div class="close animated fadeIn" @click="close">
            <i class="iconfont icon-guanbi"></i>
        </div>
        <div class="media-container animated fadeInDown">
            <div class="title-info">
                <div class="thumb" :style="'background-image:url('+projectIntro.projectInfo.cover_pic+')'">
                </div>
                <div class="text-info">
                    <div class="title">{{projectIntro.projectInfo.title}}</div>
                    <div class="sub-info">{{projectIntro.projectInfo.cate_name}} | {{projectIntro.projectInfo.year}} | {{projectIntro.projectInfo.city_name}}</div>
                </div>
            </div>
            <div class="content" v-html="projectIntro.projectInfo.details"></div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        name: "preview",
        data() {
            return {
                currImageIndex: 0
            }
        },
        methods: {
            close: function () {
                this.projectIntro.show = false;
                this.$store.commit('setProjectIntro', this.projectIntro)
            }
        },
        computed: {
            swiper() {
                return this.$refs.imageSwiper.swiper
            },
            ...mapGetters([
                'projectIntro'
            ]),
        },
        mounted: function () {
            this.currImageIndex = 0;
        }
    }
</script>

<style scoped lang="less">
    .preview-container {
        position: absolute;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.5);
        z-index: 100;
        padding-top: 15vh;
    }

    .close {
        position: absolute;
        width: 50px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        top: 4vh;
        right: 16vw;
        background: #fff;
        border-radius: 100px;
        cursor: pointer;
    }

    .media-container {
        margin: 0 auto;
        width: 800px;
        background: #fff;
        border-radius: 5px;
        padding: 35px;
        position: relative;
        .content{
            color: #666666;
            font-size: 14px;
            line-height: 2;
        }
    }
    .title-info{
        display: flex;
        margin-bottom: 25px;
        .thumb{
            width: 100px;
            height: 100px;
            background: center center no-repeat;
            background-size: cover;
            border-radius: 6px;
        }
        .text-info{
            margin-left: 35px;
            .title{
                font-size: 25px;
                color: #000000;
                margin-bottom: 25px;
            }
            .sub-info{
                font-size: 16px;
                color: #999999;
            }
        }
    }
</style>